// Утилиты для фильтрации данных

// Получение всех возможных значений для фильтров из данных
export const getAllFilterOptions = (data, isAdmin = true) => {
  if (!data.length) return { ink: [], company: [], vacancy: [], manager: [] };

  const allInks = [...new Set(data.map((item) => item.ink))].sort(
    (a, b) => a - b
  );
  const allCompanies = [...new Set(data.map((item) => item.company))].sort();
  const allVacancies = [
    ...new Set(data.flatMap((item) => item.vacs.map((vac) => vac.vacancy))),
  ].sort();
  const allManagers = [
    ...new Set(data.flatMap((item) => item.vacs.map((vac) => vac.manager))),
  ].sort();

  return {
    ink: allInks,
    company: allCompanies,
    vacancy: allVacancies,
    manager: allManagers,
  };
};

// Получение доступных опций фильтров с учетом текущих фильтров
export const getFilterOptions = (data, filters, isAdmin = true) => {
  if (!data.length)
    return {
      ink: [],
      company: [],
      vacancy: [],
      manager: [],
      availableInks: [],
      availableCompanies: [],
      availableVacancies: [],
      availableManagers: [],
    };

  let filteredDataForVacancies = data;
  let filteredDataForCompanies = data;
  let filteredDataForInks = data;
  let filteredDataForManagers = data;

  // ФИЛЬТРАЦИЯ ДЛЯ ВАКАНСИЙ
  if (filters.company.length > 0) {
    filteredDataForVacancies = filteredDataForVacancies.filter((inkGroup) =>
      filters.company.includes(inkGroup.company)
    );
  }
  if (filters.ink.length > 0) {
    filteredDataForVacancies = filteredDataForVacancies.filter((inkGroup) =>
      filters.ink.includes(inkGroup.ink)
    );
  }
  if (filters.manager.length > 0) {
    filteredDataForVacancies = filteredDataForVacancies
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.manager.includes(vac.manager)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }

  // ФИЛЬТРАЦИЯ ДЛЯ КОМПАНИЙ
  if (filters.ink.length > 0) {
    filteredDataForCompanies = filteredDataForCompanies.filter((inkGroup) =>
      filters.ink.includes(inkGroup.ink)
    );
  }
  if (filters.vacancy.length > 0) {
    filteredDataForCompanies = filteredDataForCompanies
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.vacancy.includes(vac.vacancy)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }
  if (filters.manager.length > 0) {
    filteredDataForCompanies = filteredDataForCompanies
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.manager.includes(vac.manager)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }

  // ФИЛЬТРАЦИЯ ДЛЯ ИНК
  if (filters.company.length > 0) {
    filteredDataForInks = filteredDataForInks.filter((inkGroup) =>
      filters.company.includes(inkGroup.company)
    );
  }
  if (filters.vacancy.length > 0) {
    filteredDataForInks = filteredDataForInks
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.vacancy.includes(vac.vacancy)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }
  if (filters.manager.length > 0) {
    filteredDataForInks = filteredDataForInks
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.manager.includes(vac.manager)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }

  // ФИЛЬТРАЦИЯ ДЛЯ МЕНЕДЖЕРОВ
  if (filters.ink.length > 0) {
    filteredDataForManagers = filteredDataForManagers.filter((inkGroup) =>
      filters.ink.includes(inkGroup.ink)
    );
  }
  if (filters.company.length > 0) {
    filteredDataForManagers = filteredDataForManagers.filter((inkGroup) =>
      filters.company.includes(inkGroup.company)
    );
  }
  if (filters.vacancy.length > 0) {
    filteredDataForManagers = filteredDataForManagers
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vac) =>
          filters.vacancy.includes(vac.vacancy)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }

  const allInks = [...new Set(data.map((item) => item.ink))].sort(
    (a, b) => a - b
  );
  const allCompanies = [...new Set(data.map((item) => item.company))].sort();
  const allVacancies = [
    ...new Set(data.flatMap((item) => item.vacs.map((vac) => vac.vacancy))),
  ].sort();
  const allManagers = [
    ...new Set(data.flatMap((item) => item.vacs.map((vac) => vac.manager))),
  ].sort();

  const availableInks = [
    ...new Set(filteredDataForInks.map((item) => item.ink)),
  ].sort((a, b) => a - b);
  const availableCompanies = [
    ...new Set(filteredDataForCompanies.map((item) => item.company)),
  ].sort();
  const availableVacancies = [
    ...new Set(
      filteredDataForVacancies.flatMap((item) =>
        item.vacs.map((vac) => vac.vacancy)
      )
    ),
  ].sort();
  const availableManagers = [
    ...new Set(
      filteredDataForManagers.flatMap((item) =>
        item.vacs.map((vac) => vac.manager)
      )
    ),
  ].sort();

  return {
    ink: allInks,
    company: allCompanies,
    vacancy: allVacancies,
    manager: allManagers,
    availableInks,
    availableCompanies,
    availableVacancies,
    availableManagers,
  };
};

// Фильтрация данных таблицы
export const filterTableData = (data, filters, isAdmin = true) => {
  if (!data.length) return [];

  let filteredData = data;

  // ВЫСШИЙ ПРИОРИТЕТ: фильтр по менеджеру
  if (filters.manager.length > 0) {
    filteredData = filteredData
      .map((inkGroup) => ({
        ...inkGroup,
        vacs: inkGroup.vacs.filter((vacancyGroup) =>
          filters.manager.includes(vacancyGroup.manager)
        ),
      }))
      .filter((inkGroup) => inkGroup.vacs.length > 0);
  }

  // СУЩЕСТВУЮЩАЯ ЛОГИКА ФИЛЬТРАЦИИ
  filteredData = filteredData
    .filter((inkGroup) => {
      if (filters.ink.length > 0 && !filters.ink.includes(inkGroup.ink))
        return false;
      if (
        filters.company.length > 0 &&
        !filters.company.includes(inkGroup.company)
      )
        return false;
      return true;
    })
    .map((inkGroup) => ({
      ...inkGroup,
      vacs: inkGroup.vacs.filter((vacancyGroup) => {
        if (
          filters.vacancy.length > 0 &&
          !filters.vacancy.includes(vacancyGroup.vacancy)
        )
          return false;
        return true;
      }),
    }))
    .filter((inkGroup) => inkGroup.vacs.length > 0);

  return filteredData;
};

// Преобразование отфильтрованных данных в плоскую структуру для таблицы
export const getFlatTableData = (filteredData, isAdmin = true) => {
  return filteredData.flatMap((inkGroup) =>
    inkGroup.vacs.map((vacancyGroup) => ({
      ink: inkGroup.ink,
      company: inkGroup.company,
      vacancy: vacancyGroup.vacancy,
      manager: vacancyGroup.manager,
      respondCount: vacancyGroup.respondCount,
      intervalCounts: vacancyGroup.intervalCounts || [],
      intervalSources: vacancyGroup.intervalSources || [],
      totalResponds: inkGroup.totalResponds,
      responds: vacancyGroup.responds,
    }))
  );
};

// Очистка фильтра с учетом зависимостей
export const clearFilterWithDependencies = (filters, filterType) => {
  const newFilters = { ...filters, [filterType]: [] };

  if (filterType === "company" && newFilters.vacancy.length === 0) {
    newFilters.ink = [];
  } else if (filterType === "ink" && newFilters.vacancy.length === 0) {
    newFilters.company = [];
  } else if (filterType === "manager") {
    newFilters.manager = [];
  } else if (filterType === "all") {
    newFilters.ink = [];
    newFilters.company = [];
    newFilters.vacancy = [];
    newFilters.manager = [];
  }

  return newFilters;
};

// Обновление фильтра при изменении значения
export const updateFilter = (filters, filterType, value) => {
  const newFilters = { ...filters };

  if (newFilters[filterType].includes(value)) {
    newFilters[filterType] = newFilters[filterType].filter(
      (item) => item !== value
    );
  } else {
    newFilters[filterType] = [...newFilters[filterType], value];
  }

  return newFilters;
};

export const getSourceStats = (responds, intervalStart, intervalEnd) => {
  const sourceCounts = { avito: 0, yandex: 0, vk: 0 };

  if (!responds || !Array.isArray(responds)) return sourceCounts;

  responds.forEach((respond) => {
    if (respond && respond.source) {
      const respondDate = new Date(respond.ts);
      const intervalStartStartOfDay = new Date(intervalStart);
      intervalStartStartOfDay.setHours(0, 0, 0, 0);
      const intervalEndEndOfDay = new Date(intervalEnd);
      intervalEndEndOfDay.setHours(23, 59, 59, 999);

      if (
        respondDate >= intervalStartStartOfDay &&
        respondDate <= intervalEndEndOfDay
      ) {
        const source = respond.source.toLowerCase();
        if (sourceCounts.hasOwnProperty(source)) {
          sourceCounts[source]++;
        }
      }
    }
  });

  return sourceCounts;
};

// Сбор общей статистики по источникам для всех откликов
export const getTotalSourceStats = (responds) => {
  const sourceCounts = { avito: 0, yandex: 0, vk: 0 };

  if (!responds || !Array.isArray(responds)) return sourceCounts;

  responds.forEach((respond) => {
    if (respond && respond.source) {
      const source = respond.source.toLowerCase();
      if (sourceCounts.hasOwnProperty(source)) {
        sourceCounts[source]++;
      }
    }
  });

  return sourceCounts;
};
